import PropTypes from "prop-types";
import "./style.scss";

const ProgressLine = ({
  orientation,
  color,
  dashed,
  thickness,
  length,
  borderColorData,
  position,
  bottom,
}) => {
  const isVertical = orientation === "vertical";
  const lineStyle = {
    backgroundColor: color,
    width: isVertical ? `${thickness}vw` : `${length}vw`,
    height: isVertical ? `${length}px` : `${thickness}px`,
    borderStyle: dashed ? "dashed" : "solid",
    borderWidth: dashed ? `${thickness}px` : "0",
    borderColor: dashed
      ? borderColorData
        ? borderColorData
        : color
      : "transparent",
    position: position,
    bottom: bottom,
  };

  return (
    <span
      className={`progress-line ${isVertical ? "vertical" : "horizontal"}`}
      style={lineStyle}
    ></span>
  );
};

ProgressLine.propTypes = {
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  color: PropTypes.string,
  dashed: PropTypes.bool,
  thickness: PropTypes.number,
  length: PropTypes.number,
};



export default ProgressLine;
